"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_data(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "data-hi"), /*#__PURE__*/React.createElement("g", {
    id: "2b66fe4d-69ac-42cf-963b-61372c7557a5",
    "data-name": "data-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3cdb4cb8-1085-4990-afdb-a27409f05d08",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ed9bf189-1ff1-4eb2-a9d4-7483e4a2063f",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "92607144-8315-4cfa-ac43-dcdf0e874d39",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6759a3fa-82ff-4f0d-8a82-f31800ce5300",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ed964f52-2e83-4415-8777-d169527bbbf6",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5c137028-9965-482e-9cc0-ade2c22e273b",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dbc98234-5076-47d3-a95c-2eab3c5581d2",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cd5e752f-4f00-46a2-a2cb-958431aea4f2",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "99890a3c-8051-4f9c-8f43-66d7d6a57562",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.34,124H144V84a16,16,0,0,0-16-16H96v56H81.66a4,4,0,0,0-2.83,6.83L120,172l41.17-41.17A4,4,0,0,0,158.34,124Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.67,68H48v40a16,16,0,0,0,16,16H96V68h14.34a4,4,0,0,0,2.83-6.83L72,20,30.85,61.17A4,4,0,0,0,33.67,68Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48,66H33.67a3.93,3.93,0,0,1-3.84-3,4,4,0,0,0,3.84,5H48Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,106v2a16,16,0,0,0,16,16H96v-2H64A16,16,0,0,1,48,106Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.36,66H96v2h14.34a4,4,0,0,0,3.84-5A3.93,3.93,0,0,1,110.36,66Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M161.17,128.83,120,170,78.83,128.83a3.91,3.91,0,0,1-1-1.8,3.88,3.88,0,0,0,1,3.8L120,172l41.17-41.17a3.88,3.88,0,0,0,1-3.8A3.91,3.91,0,0,1,161.17,128.83Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "26ccf54a-937c-45a6-aa4f-e12304e304d7",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }))))))))))));
}

var _default = ic_data;
exports.default = _default;